module.exports = __webpack_public_path__ + "img/产权交易.a38c39fd.png";